module.exports = __webpack_public_path__ + "static/hyperv_5.d9309375.jpg";